import React from "react"
import { Container, Heading, Button } from "@chakra-ui/react"
import { withSection } from "@app/hoc/Section"
import "./InstagramProducts.css"

import Link from "@components/Link"

type Props = {
  title: string
  subtitle?: string
  ctaLink?: any
  innerRef: any
}

const InstagramProducts: React.FC<Props> = ({ title, subtitle, ctaLink, innerRef }) => {
  return (
    <Container className="yotpo-instagram-products" ref={innerRef} as="section" maxW="11xl" px={[4, 8]} py={[8, 16]} textAlign="center">
      <Heading as="h3" size="xs" fontWeight={"medium"} mb={2}>
        {subtitle}
      </Heading>
      {title && (
        <Heading as="h2" size="xl">
          <a href={`https://instagram.com/${title?.replace("@", "")}`} target="_blank" rel="noreferrer">
            {title}
          </a>
        </Heading>
      )}
      <div className="yotpo yotpo-pictures-widget" data-gallery-id="64a664393c189f0013a9064f"></div>
      <Link to={ctaLink.link}>
        <Button variant="blue">{ctaLink.title}</Button>
      </Link>
    </Container>
  )
}

export default React.memo(withSection(InstagramProducts))
